export interface PaymentProgramChangeRequest {
  source: 'llp_marketplace' | 'llp_payments';
  publicId: string;
  resourceId: string;
  resourceType: 'invoice' | 'order' | 'contract' | 'company';
  counterParty: {
    id: string;
    type: 'seller' | 'buyer';
    dba: string;
    name: string | null;
    marketplaceId: number;
    marketplaceSlug: string;
  };
  company: {
    id: string;
    type: 'seller' | 'buyer';
    dba: string;
    name: string | null;
    marketplaceId: number;
    marketplaceSlug: string;
  };
  status: PaymentProgramChangeRequestStatus;
  statusModifiedTime: Date;
  requestedTime: Date;
  paymentProgram: 'direct' | 'flexible' | 'post' | 'do_not_process';
  contractEligibleInvoiceTotal: string;
  seenBy: number[];
}

/**
 * Pending: Seen but no action on it
 * Dismissed: Seen, clicked maybe later
 * In Progress: Clicked sign up, but not yet on b2b
 * Accepted: Clicked sign up
 */
export enum PaymentProgramChangeRequestStatuses {
  Accepted = 'accepted',
  Dismissed = 'dismissed',
  Pending = 'pending',
  InProgress = 'in_progress',
}

export type PaymentProgramChangeRequestStatus = `${PaymentProgramChangeRequestStatuses}`;
